import type { IClientContext, IClientContextAction } from './ClientContext.typings';

export function clientContextReducer(prev: IClientContext, action: IClientContextAction): IClientContext {
    switch (action.event) {
        case 'set_initial_data': {
            const { user } = action;

            return {
                ...prev,
                userInfo: user,
            };
        }

        case 'update_user_info': {
            return {
                ...prev,
                userInfo: action.user,
            };
        }

        case 'set_language': {
            return {
                ...prev,
                lang: action.lang,
            };
        }

        case 'set_theme': {
            return {
                ...prev,
                theme: action.theme,
            };
        }
    }

    return prev;
}
